import React, { useState } from 'react';
import { Alert, Button, Form } from 'react-bootstrap';
import { FaLock } from 'react-icons/fa';
import { reauthenticateWithCredential, updatePassword, EmailAuthProvider } from 'firebase/auth';
import { auth } from '../../firebase/firebase-config';
import { resolveFirebaseAuthError } from '../../platform/authErrorMessages';

function ProfileSecurity() {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [passwordSuccess, setPasswordSuccess] = useState('');

  const handlePasswordChange = async (event) => {
    event.preventDefault();
    setPasswordError('');
    setPasswordSuccess('');

    if (!auth.currentUser) {
      setPasswordError('Uporabnik ni prijavljen.');
      return;
    }

    if (!currentPassword || !newPassword) {
      setPasswordError('Prosimo, izpolnite vsa polja za spremembo gesla.');
      return;
    }

    try {
      const credential = EmailAuthProvider.credential(auth.currentUser.email, currentPassword);
      await reauthenticateWithCredential(auth.currentUser, credential);
      await updatePassword(auth.currentUser, newPassword);
      setPasswordSuccess('Geslo je bilo uspešno posodobljeno!');
      setCurrentPassword('');
      setNewPassword('');
    } catch (error) {
      setPasswordError(resolveFirebaseAuthError(error, { context: 'passwordChange' }));
    }
  };

  return (
    <div className="profile-subpage">
      <div className="platform-form-card profile-settings-card">
        <div className="platform-form-card__body">
          <div className="profile-settings-card__intro">
            <div className="profile-settings-card__icon" aria-hidden="true">
              <FaLock />
            </div>
            <div>
              <p className="profile-settings-card__lead">
                Posodobite geslo za dostop do portala. Zaradi varnosti morate potrditi trenutno geslo.
              </p>
            </div>
          </div>

          <Form onSubmit={handlePasswordChange} className="profile-settings-form">
            <Form.Group className="mb-3" controlId="formCurrentPassword">
              <Form.Label>Trenutno geslo</Form.Label>
              <Form.Control
                type="password"
                placeholder="Vnesite trenutno geslo"
                value={currentPassword}
                onChange={(event) => setCurrentPassword(event.target.value)}
                required
                autoComplete="current-password"
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formNewPassword">
              <Form.Label>Novo geslo</Form.Label>
              <Form.Control
                type="password"
                placeholder="Vnesite novo geslo"
                value={newPassword}
                onChange={(event) => setNewPassword(event.target.value)}
                required
                minLength={6}
                autoComplete="new-password"
              />
            </Form.Group>

            <div className="profile-security-tips profile-settings-form__full">
              <p className="profile-security-tips__title">Priporočila za geslo</p>
              <ul className="profile-security-tips__list">
                <li>Naj bo dolgo vsaj 6 znakov.</li>
                <li>Uporabite kombinacijo črk in številk.</li>
                <li>Ne uporabljajte istega gesla kot drugje.</li>
              </ul>
            </div>

            <div className="profile-settings-form__full profile-settings-form__actions">
              <Button variant="primary" type="submit">
                Spremeni geslo
              </Button>
            </div>

            {passwordSuccess && (
              <Alert variant="success" className="mt-3 mb-0 profile-settings-form__full">
                {passwordSuccess}
              </Alert>
            )}

            {passwordError && (
              <Alert variant="danger" className="mt-3 mb-0 profile-settings-form__full">
                {passwordError}
              </Alert>
            )}
          </Form>
        </div>
      </div>
    </div>
  );
}

export default ProfileSecurity;
